module.exports = __webpack_public_path__ + "static/img/gg3.d3cfcb6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gg3.png
// module id = ugP0
// module chunks = 1